interface SectionHeaderProps {
  subtitle: string
  title: string
}

function SectionHeader({ subtitle, title }: SectionHeaderProps) {
  return (
    <>
      <p className="uppercase text-xs md:text-sm tracking-wider mb-4">
        {subtitle}
      </p>
      <h1
        className="text-xl md:text-4xl font-medium mb-12"
        dangerouslySetInnerHTML={{ __html: title }}
      />
    </>
  )
}

export default SectionHeader
